import './App.css';
import About from './Components/About';
import Contact from './Components/Contact';
import Footer from './Components/Footer';
import Land from './Components/Land';
import '@radix-ui/themes/styles.css';
import Login from './Components/Login';
import Navbar from './Components/Navbar';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { Theme } from '@radix-ui/themes';
import Signup from './Components/SIgnup';
import 'react-toastify/dist/ReactToastify.css';
import ForgotPassword from './Components/ForgotPassword';
import { ToastContainer } from 'react-toastify';
import Home from './Components/Home';
import PrivateRoute from './Components/PrivateRoute';
import AddItem from './Components/AddItem';
import NonPrivateRoute from './Components/NonPrivateRoute';
import ResetPassword from './Components/ResetPassword';
import FetchItems from './Components/FetchItems';
import EditItemForm from './Components/EditItemForm';
import NotFoundPage from './Components/NotFound';
function App() {
  return (
    <Router>
      <Theme>
      <ToastContainer/>
      <Navbar />
      <Routes>
        <Route exact path='/' element={<NonPrivateRoute/>}>
        <Route exact path='/' element={<Land/>}/>
        </Route>
        <Route exact path='/home' element={<PrivateRoute/>}>
        <Route exact path='/home' element={<Home/>}/>
        </Route>
        <Route exact path='/additem' element={<PrivateRoute/>}>
        <Route exact path='/additem' element={<AddItem/>}/>
        </Route>
        <Route exact path="/about" element={<About />} /> 
        <Route exact path="/login" element={<NonPrivateRoute />}>
        <Route exact path="/login" element={<Login />} />
        </Route>
        <Route exact path="/signup" element={<NonPrivateRoute />}>
        <Route exact path="/signup" element={<Signup />} />
        </Route>
        <Route exact path="/forgotpassword" element={<NonPrivateRoute />}>
        <Route exact path="/forgotpassword" element={<ForgotPassword />} />
        </Route>
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/fetchitems" element={<FetchItems />} />
        <Route path="/resetpassword/:token" element={<ResetPassword/>} /> 
        <Route path="/edititem/:id" element={<EditItemForm/>} />
        <Route path="*" element={<NotFoundPage/>} />
      </Routes>
      <Footer/>
      </Theme>
    </Router>
  );
}

export default App;
